import { commonHelpers } from 'helpers/commonHelper';
import { dateHelper } from 'helpers/dateHelper';
import { getTableHeightFitContent } from 'helpers/lib/reactDataGridHelpers';
import { get } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import ReactDataGrid from 'react-data-grid';

const EmptyRowsView = () => {
    const message = 'Chưa có mục chi nào';
    return (
        <div style={{ textAlign: 'center', backgroundColor: '#ddd', padding: '100px' }}>
            <h3>{message}</h3>
        </div>
    );
};

function DuChiCaNhanTable({ academicYear, duchicanhans, danhmucduchicanhans, data, setData }) {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const numOfMonthForYear = get(academicYear, 'congDoanNumOfMonth', 12);
    const congDoanStartMonth = get(academicYear, 'congDoanStartMonth', 5);

    const [tableHeight, setTableHeight] = useState();
    useEffect(() => {
        setTableHeight(getTableHeightFitContent());
    }, []);

    useEffect(() => {
        const rows = [];
        if (danhmucduchicanhans) {
            danhmucduchicanhans.forEach((dm) => {
                const matchedDuChiCaNhan = duchicanhans ? duchicanhans.find((duchi) => dm.code === duchi.danhMucChiCongDoanCode) : {};
                const row = {
                    dmId: dm.id,
                    code: dm.code,
                    name: dm.name,
                    id: get(matchedDuChiCaNhan, 'id'),
                    danhMucChiCongDoanCode: get(matchedDuChiCaNhan, 'danhMucChiCongDoanCode'),
                    junAmount: get(matchedDuChiCaNhan, 'junAmount', '') ? get(matchedDuChiCaNhan, 'junAmount', '') : '',
                    julAmount: get(matchedDuChiCaNhan, 'julAmount', '') ? get(matchedDuChiCaNhan, 'julAmount', '') : '',
                    augAmount: get(matchedDuChiCaNhan, 'augAmount', '') ? get(matchedDuChiCaNhan, 'augAmount', '') : '',
                    sepAmount: get(matchedDuChiCaNhan, 'sepAmount', '') ? get(matchedDuChiCaNhan, 'sepAmount', '') : '',
                    octAmount: get(matchedDuChiCaNhan, 'octAmount', '') ? get(matchedDuChiCaNhan, 'octAmount', '') : '',
                    novAmount: get(matchedDuChiCaNhan, 'novAmount', '') ? get(matchedDuChiCaNhan, 'novAmount', '') : '',
                    decAmount: get(matchedDuChiCaNhan, 'decAmount', '') ? get(matchedDuChiCaNhan, 'decAmount', '') : '',
                    janAmount: get(matchedDuChiCaNhan, 'janAmount', '') ? get(matchedDuChiCaNhan, 'janAmount', '') : '',
                    febAmount: get(matchedDuChiCaNhan, 'febAmount', '') ? get(matchedDuChiCaNhan, 'febAmount', '') : '',
                    marAmount: get(matchedDuChiCaNhan, 'marAmount', '') ? get(matchedDuChiCaNhan, 'marAmount', '') : '',
                    aprAmount: get(matchedDuChiCaNhan, 'aprAmount', '') ? get(matchedDuChiCaNhan, 'aprAmount', '') : '',
                    mayAmount: get(matchedDuChiCaNhan, 'mayAmount', '') ? get(matchedDuChiCaNhan, 'mayAmount', '') : '',
                    extraAmount1: get(matchedDuChiCaNhan, 'extraAmount1', '') ? get(matchedDuChiCaNhan, 'extraAmount1', '') : '',
                    extraAmount2: get(matchedDuChiCaNhan, 'extraAmount2', '') ? get(matchedDuChiCaNhan, 'extraAmount2', '') : '',
                    duchi: matchedDuChiCaNhan,
                };
                rows.push(row);
            });
            setRows(rows);
        }
    }, [duchicanhans, danhmucduchicanhans]);

    const buildDynamicColumnBaseOnYear = useCallback(() => {
        const isEditable = commonHelpers.ableToPersitDuThuChi(academicYear.name);
        const fieldMap = dateHelper.duThuFieldMappedByMonth();
        const extraKeys = ['extraAmount1', 'extraAmount2'];

        const columns = [];
        for (let i = 0; i < numOfMonthForYear; i++) {
            const position = i + 1; // 1-based position in the sequence
            const month = ((congDoanStartMonth - 1 + i) % 12) + 1;
            const key = position <= 12 ? fieldMap.get(month) : extraKeys[position - 13];
            columns.push({ key, name: `Tháng ${month}`, editable: isEditable, width: 80 });
        }
        return columns;
    }, [numOfMonthForYear, congDoanStartMonth]);

    useEffect(() => {
        const commonColumns = [
            { key: 'code', name: 'Mã số', editable: false, width: 60 },
            { key: 'name', name: 'Diễn giải', editable: false, width: 360 },
        ];
        const dynamicColumns = buildDynamicColumnBaseOnYear();
        const columns = [...commonColumns, ...dynamicColumns].map((item) => {
            return { ...item, ...{ resizable: true } };
        });
        setColumns(columns);
    }, [buildDynamicColumnBaseOnYear]);

    const onGridRowsUpdated = ({ fromRow, toRow, updated, cellKey }) => {
        const newData = new Map(data);
        const newRows = [...rows];
        for (let i = fromRow; i <= toRow; i++) {
            newRows[i] = { ...newRows[i], ...updated };
            if (get(newRows[i], 'dm.id', false) || updated[cellKey] !== '') {
                newData.set(i, newRows[i]);
            }
        }
        setRows(newRows);
        setData(newRows);
    };

    return (
        <div id="rdg">
            <ReactDataGrid
                columns={columns}
                rowGetter={(i) => rows[i]}
                rowsCount={rows.length}
                minHeight={tableHeight}
                enableCellSelect={true}
                onGridRowsUpdated={onGridRowsUpdated}
                emptyRowsView={EmptyRowsView}
            />
        </div>
    );
}

export default DuChiCaNhanTable;
